import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LeaderboardComponent } from './content/leaderboard/leaderboard.component';
import { ChallengesComponent } from './content/challenges/challenges.component';
import { SubmissionsComponent } from './content/submissions/submissions.component';
import { LoginComponent } from './content/login/login.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'logout', redirectTo: '/login', pathMatch: 'full' },
  { path: 'leaderboard', component: LeaderboardComponent },
  { path: 'challenges', component: ChallengesComponent },
  { path: 'login', component: LoginComponent },
  { path: 'submissions', component: SubmissionsComponent }
];

@NgModule({
  exports: [ RouterModule ],
  imports: [ RouterModule.forRoot(routes) ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/boshaughnessy/Documents/Web/ClonkeenChallenge/clonkeen-challenge/src/app/app-routing.module.ts